<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'riwayat-pesan'" :bg-grey="true">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar page-title="Riwayat pengiriman pesan" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:empty-state>
                <SOEmptyState
                    v-if="listPesan.length === 0 && !isFetching"
                    :message="'Tidak Ada Pesan'"
                    :subMessage="'Riwayat pengiriman pesan akan tampil disini'"
                />
            </template>
            <template v-slot:content>
                <div class="">
                    <div class="d-flex f-12 f-c-midgrey f-regular data-device">
                        <div class="no-telp">
                            <IconBased width="14" height="14">
                                <template v-slot:icons>
                                    <WhatsappIconMini clr-fill="#6F7287" />
                                </template>
                            </IconBased>
                            <span class="m-l-4">+{{ getCC }}{{ getNomorTelp }}</span>
                        </div>
                        <label class="m-d-0">{{ getNamaPerangkat }}</label>
                    </div>
                    <div class="separator-line"></div>
                    <div class="d-flex-between-center p-d-16 p-x-20 p-t-16" style="align-items: baseline;">
                        <div class="f-regular f-16 f-c-midgrey">
                            <div>
                                <label class="m-d-0">
                                    <span>Ke </span>
                                </label>
                                <label class="m-d-0 f-c-blue m-l-4" @click="doAction">
                                    <span style="margin-right: 4px">{{ customer.nama_customer }}</span>
                                    <IconBased width="12" height="6">
                                        <template v-slot:icons>
                                            <ArrowDown />
                                        </template>
                                    </IconBased>
                                </label>
                            </div>
                            <div class="f-12 f-regular sum-pesan">
                                <span>Total {{ historySummary.totalCount }} pesan. {{ historySummary.averagePerDay }} pesan / hari</span>
                            </div>
                            <div class="f-12 f-regular sum-failed-pesan" v-if="totalFailedPesan" @click="doResendAll">
                                <SOIconBase width="12" height="12" viewBox="0 0 18 17">
                                    <template v-slot:icon>
                                        <WarningTriangle1817 icon-fill="#964040" />
                                    </template>
                                </SOIconBase>
                                <span>
                                    Ada <b>{{ totalFailedPesan }} pesan gagal</b>, Kirim ulang ?</span
                                >
                            </div>
                            <div class="f-12 f-regular " v-if="isDefaultFilter">
                                <span>Default, menampilkan pesan 3 hari terakhir. Klik filter untuk mengubah</span>
                            </div>
                        </div>
                        <div class="f-semi f-16 f-c-blue" @click="setFilter(true)">
                            Filter
                            <span class="filter-count" v-if="appliedFilter > 0">
                                {{ appliedFilter }}
                            </span>
                            <IconBased width="14" height="12" v-else>
                                <template v-slot:icons>
                                    <FilterIcon />
                                </template>
                            </IconBased>
                        </div>
                    </div>
                    <div class="p-x-20">
                        <CardPesan :data-list="listPesan" />
                    </div>
                    <SOLoadMoreLoading :id="'load-more-pesan'" :loading="isLoadMore || isLoadData" />
                </div>
            </template>
            <template v-slot:filter>
                <SOFilter
                    v-if="isFilter"
                    :filter-pesan-whatsapp="true"
                    :sorting="getSorting"
                    @back="setFilter(false)"
                    @do-filter="doFilter"
                    @reset-filter="resetFilter"
                />
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFilter from "@/so-components/global/filter/base/SOFilter";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";

import IconBased from "../components/iconPack/IconBased.vue";
import WhatsappIconMini from "../components/iconPack/WhatsappIcon1414.vue";
import FilterIcon from "../components/iconPack/FilterIcon.vue";
import ArrowDown from "../components/iconPack/ArrowDown1206.vue";
import CardPesan from "../components/CardPesan.vue";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import WarningTriangle1817 from "@/so-components/global/icons/iconPacks/WarningTriangle1817.vue";

import { moduleName } from "../store/state";
import Sorting from "../static/sorting";

export default {
    name: "RiwayatPesan",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOLoadMoreLoading,
        SOFilter,
        SOEmptyState,
        IconBased,
        WhatsappIconMini,
        FilterIcon,
        ArrowDown,
        CardPesan,
        SOIconBase,
        WarningTriangle1817,
    },
    data() {
        return {
            page: "",
            appliedFilter: 0,
            isDefaultFilter: 1,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.setPage(to.name);
            if (
                to.name === "wa_autosender.detail_perangkat.riwayat_pesan" &&
                from.name !== "wa_autosender.detail_perangkat.riwayat_pesan.detail_message"
            ) {
                vm.init();
            }
        });
    },
    watch: {
        filterItem: {
            handler: function() {
                this.countAppliedFilter();
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            isFilter: "isFilter",
            dataDevice: "dataDevice",
            dataDeviceTiny: "dataDeviceTiny",
            listPesan: "listPesan",
						historySummary: "historySummary",
            totalFailedPesan: "totalFailedPesan",
            customer: "customer",
        }),
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        getSorting() {
            return Sorting;
        },
        getIdDevice() {
            return this.$route.params.id_device;
        },
        getNumber() {
            return this.customer.number;
        },
        getCC() {
            return this.dataDevice?.country_code || this.dataDeviceTiny.country_code;
        },
        getNomorTelp() {
            return this.dataDevice?.nomor || this.dataDeviceTiny.number;
        },
        getNamaPerangkat() {
            return this.dataDevice.nomor ? this.dataDevice.nama : this.dataDeviceTiny.nama;
        },
        isLoadData() {
            return this.page === "wa_autosender.detail_perangkat.riwayat_pesan" ? this.isFetching : false;
        },
    },
    methods: {
        ...mapActions({
            setFilter: `${moduleName}/setFilter`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            getHistoryPesanV2: `${moduleName}/getHistoryPesanV2`,
            setSelectedCustomer: `${moduleName}/setSelectedCustomer`,
            resetListPesan: `${moduleName}/resetListPesan`,
            resetPagePesan: `${moduleName}/resetPagePesan`,
						getHistorySummary: `${moduleName}/getHistorySummary`,
        }),
        async init() {
            if (!this.dataDevice.nomor) {
                await this.getDetailTinyDevice({ id_mesin: this.getIdDevice });
            }
            if (this.listPesan.length === 0) {
                let { number } = this.customer;
								this.getHistorySummary({ iddevice: this.getIdDevice, nomor: number !== "all" ? number : "" });
                await this.resetPagePesan();
                await this.resetFilter();
                await this.getHistoryPesanV2({
                    idMesin: this.getIdDevice,
                    nomor: number !== "all" ? number : "",
                });
            }
        },
        async back() {
            await this.resetListPesan();
            await this.setSelectedCustomer({ idcustomer: "all", nama_customer: "Semua nomor" });
            await this.$router.push({ name: "wa_autosender.detail_perangkat" });
        },
        setPage(val) {
            this.page = val;
        },
        countAppliedFilter() {
            this.appliedFilter = 0;
            for (let f in this.filterItem) {
                if (f === "sorting") {
                    continue;
                }
                if (Array.isArray(this.filterItem[f])) {
                    if (this.filterItem[f].length > 0) {
                        this.appliedFilter++;
                    }
                }
                if (typeof this.filterItem[f] === "string") {
                    if (this.filterItem[f] === "0") {
                        continue;
                    }
                    if (this.filterItem[f] !== "") {
                        this.appliedFilter++;
                    }
                }
            }
            if (this.filterItem.periode.filterBy !== "") {
                this.appliedFilter++;
            }
        },
        async doAction() {
            await this.$router.push({ name: "wa_autosender.detail_perangkat.riwayat_pesan.search_number" });
        },
        async doFilter() {
            this.isDefaultFilter = 0;
            await this.resetPagePesan();
            await this.resetListPesan();
            await this.setFilter(false);
            await this.getHistoryPesanV2({
                idMesin: this.getIdDevice,
                nomor: this.getNumber !== "all" ? this.getNumber : "",
            });
        },
        async resetFilter() {
            this.isDefaultFilter = 1;
            let temp = this.filterItem;
            await this.$store.commit("filterGlobalModule/resetFilterItem");
            await this.$store.commit("filterGlobalModule/setFilter", JSON.parse(this.getSorting[0].value));

            temp.periode = {
                endDate: this.$moment().format("YYYY-MM-DD"),
                filterBy: "periode",
                startDate: this.$moment()
                    .subtract(3, "days")
                    .format("YYYY-MM-DD"),
                month: "",
                year: "",
            };
            await this.$store.commit("filterGlobalModule/setFilterItem", temp);
        },

        doResendAll() {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.riwayat_pesan.resend_message",
                query: { countMsg: this.totalFailedPesan },
            });
        },
    },
};
</script>
<style scoped>
.data-device {
    background-color: #ffffff;
    align-items: baseline;
    padding: 10px 20px;
}
.no-telp {
    border: 1px solid #ededed;
    width: fit-content;
    padding: 2px 4px;
    border-radius: 4px;
    margin-right: 4px;
}
.sum-pesan {
    display: inline-block;
    border: 1px solid #c8d0dd;
    width: fit-content;
    border-radius: 3px;
    padding: 0px 4px;
    background: white;
}
.sum-failed-pesan {
    display: inline-block;
    border: 1px solid #dd0032;
    width: fit-content;
    border-radius: 3px;
    padding: 0px 4px;
    color: red;
    margin: 0px 10px;
}
</style>
